var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('PageHeader',{attrs:{"items":_vm.items}}),_vm._v(" "),(_vm.user.rol_id==1)?_c('Administrador'):_vm._e(),_vm._v(" "),(_vm.user.rol_id==2)?_c('Director',{attrs:{"colegio":_vm.user.colegio_id}}):_vm._e(),_vm._v(" "),(_vm.user.rol_id!=1 && _vm.user.rol_id!=2)?_c('Usuario'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }